import React from 'react';
import './TeacherLMSMain.css';

const TeacherLMSMain = () => (
  <div className="academy-page-shell teacher-lms-main">
    <div className="lms-main-welcome">
      <h1>Welcome, Teacher!</h1>
      <p className="lms-main-desc">Manage your classes, assignments, and students. Use the sidebar to access your teaching tools.</p>
      <div className="lms-main-graphic teacher"></div>
    </div>
  </div>
);

export default TeacherLMSMain;
